import { JSX } from 'react';
import { C55BiographyDirectoryProps } from './C55BiographyDirectory.types';
import { BioCardDirectory } from '@ahc-digital/component-library';
import { GetBiographyDirectoryModel } from './C55BiographyDirectory.service';
import { useCreateMarketingRenderingHame } from '@/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C55BiographyDirectoryProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <BioCardDirectory
      data-component={marketingRenderingName}
      {...GetBiographyDirectoryModel(props)}
    />
  );
};

export default checkDatasourceForRendering<C55BiographyDirectoryProps>(Default);
